import L from 'leaflet';

// Turn the edit mode on
// When we start drawing we need to turn edit mode off
const enableDrawPolygon = () => {
    L.toolbar._toolbars?.draw?._modes?.polygon?.handler?.enable();
    L.toolbar._toolbars?.edit?._modes?.edit?.handler?.disable();

    // drawControls?._toolbars?.draw?._activeMode?.handler?._poly?.setStyle(DRAWING_STYLES);
    // console.log('drawControls', drawControls)
};

export function disableDrawPolygon() {
    L.toolbar._toolbars.draw._modes.polygon.handler.disable();
}
// When drawing done we need to enter edit mode
export function enableEditMode() {
    // drawControls?._toolbars?.draw?._activeMode?.handler?._poly?.setStyle(DRAWING_STYLES);
    // L.toolbar._toolbars.draw._modes.polygon.handler.disable();
    L.toolbar._toolbars.edit._modes.edit.handler.enable();
}

// Turn the edit mode off
export const disableEditMode = () => {
    // L.toolbar._toolbars.draw._modes.polygon.handler?.disable();
    L.toolbar._toolbars.edit._modes.edit.handler?.disable();
};

export const disableMarker = () => {
    L.toolbar._toolbars.draw._modes.marker.handler.disable();
};

export function removeClearAllButton() {
    L.EditToolbar.Delete.include({
        removeAllLayers: false,
    });
}
